/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
//import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import Video from './Video';
import { MdPlayArrow } from 'react-icons/md';

const LightboxContainer = styled.div`
  &:target {
    .lightboxModal {
      display: flex !important;
      background: rgba(0, 0, 0, 0.8);
    }
  }
`;

const LightboxPreview = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  p {
    position: absolute;
    left: -200vw;
    opacity: 0.01;
  }
  .video_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4rem;
    line-height: 1em;
    width: 1.5em;
    height: 1.5em;
    position: absolute;
    bottom: 0.8rem;
    right: 0.8rem;
    background: rgba(0, 0, 0, 0.56);
    border-radius: 100%;
  }
`;
const LightboxModal = styled.div`
  /** Default lightbox to hidden */
  display: none;

  /** Position and style */
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  background: transparent;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  img {
    /** Pad the lightbox image */
    max-width: 100%;
    max-height: none;
    margin: 4px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    position: relative;
    z-index: 50;
  }
  &:target {
    /** Remove default browser outline */
    outline: none;
    display: flex;
  }
  .closeLightbox {
    z-index: 1;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    transition: background 0.12s ease-in;
    &:hover {
      background: transparent;
    }
  }
`;

const ModalContainer = css`
  pointer-events: all;
  position: relative;
  z-index: 100;
  max-width: 80vw;
  max-height: 75vh;
  margin: 4rem 1.6rem;
`;
const ModalVideo = styled.div`
  ${ModalContainer};
  width: 100%;
  > .aspect_ratio_outside {
    display: block;
    position: relative;
    padding-bottom: 56.25%;
    > iframe {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: black;
    }
  }
`;
const ModalImage = styled.div`
  ${ModalContainer};
  width: auto;
`;

export const VideoIndicator = ({ isVideo }) =>
  isVideo && (
    <span className="video_icon">
      <MdPlayArrow />
      {/* <img src={PlayIcon} width="24" height="24" alt="Video Preview" /> */}
    </span>
  );

export const Lightbox = React.memo(
  ({
    title,
    description,
    type,
    imageUrl,
    imageAlt,
    video,
    isHidden,
    className,
    id,
  }) => {
    const isVideo = video != null && video != undefined;
    function backupAltText(title, desc) {
      switch ((title, desc)) {
        case title && desc:
          return title + ', ' + desc;
          break;
        case title != null && title != undefined:
          return title;
          break;
        case desc != null && desc != undefined:
          return desc;
          break;
        default:
          return 'VBI Portfolio Project';
      }
    }

    return isHidden ? (
      <LightboxContainer className={className}>
        <LightboxPreview
          href={'#' + id}
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          {isVideo && <VideoIndicator isVideo={isVideo} />}
          <p>{imageAlt || backupAltText(title, description)}</p>
        </LightboxPreview>

        {isVideo ? (
          /* lightbox container hidden with CSS */
          <LightboxModal href="#_" className="lightboxModal" id={id}>
            <ModalVideo>
              <div className="aspect_ratio_outside">
                <Video id={id} url={video} />
              </div>
            </ModalVideo>
            <a href="#_" className="closeLightbox"></a>
          </LightboxModal>
        ) : (
          /* lightbox container hidden with CSS */
          <LightboxModal href="#_" className="lightboxModal" id={id}>
            <ModalImage>
              <img
                src={imageUrl}
                alt={imageAlt || backupAltText(title, description)}
              />
            </ModalImage>
            <a href="#_" className="closeLightbox"></a>
          </LightboxModal>
        )}
      </LightboxContainer>
    ) : (
      ''
    );
  }
);

Lightbox.propTypes = {
  input: PropTypes.array,
};

export default Lightbox;
